import type {PermissionType} from '@hconnect/apiclient'
import {useCallback} from 'react'

import {checkPermission} from '../helpers'

import {usePermissionsParsedQuery} from './queries'

type UseHasPermissionParams = {
  plantId: string
  countryId: string
}

export const useHasPermission = ({
  plantId,
  countryId
}: UseHasPermissionParams): ((permissionType: PermissionType) => boolean) => {
  const {data: permissions} = usePermissionsParsedQuery()

  return useCallback(
    (permissionType: PermissionType) =>
      permissions ? checkPermission(permissionType, plantId, permissions, [countryId]) : false,
    [plantId, countryId, permissions]
  )
}
